module.exports = __webpack_public_path__ + "img/royal hospitals dr glory shoot-79.721fb764.webp";